import React, { useState, useEffect } from "react";
import "../styles/UpdateControlParameters.css"; // Optional: Add styling
import config from "../config";

function UpdateControlParameters() {
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const [data, setData] = useState(null); // State to store fetched data

  const parameterTranslations = {
    alk: "碱度",
    ca: "钙硬度",
    cl: "氯离子",
    con: "电导率",
    hn: "总硬度",
    ph: "pH",
    ptsa: "PTSA",
  };

  // Fetch data from the API when the component mounts
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${config.apiUrl}/water_control/`, {
          method: "GET",
          headers: {
            "SD-API-KEY": config.apiKey,
            "Content-Type": "application/json",
          },
          mode: "cors",
          credentials: "include",
          cache: "no-cache",
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Get the response as a Blob
        const blob = await response.blob();

        // Convert the Blob to text using the correct encoding
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const text = reader.result;
            const result = JSON.parse(text); // Parse the JSON data
            setData(result); // Store the fetched data
          } catch (parseError) {
            console.error("Failed to parse JSON:", parseError);
            setError("Failed to parse data");
          }
        };
        reader.onerror = () => {
          console.error("Failed to read blob data");
          setError("Failed to decode data");
        };
        reader.readAsText(blob, "gbk"); // Use 'gbk' or 'latin-1' if UTF-8 fails
      } catch (error) {
        console.error("获取数据失败:", error);
        setError("获取数据失败，请重试"); // Set error message
      }
    };

    fetchData();
  }, []);

  // Handle button click to invoke the API
  const handleUpdate = async () => {
    setLoading(true);
    setSuccessMessage("");
    setError("");

    try {
      const response = await fetch(`${config.apiUrl}/water_control/`, {
        method: "POST",
        headers: {
          "SD-API-KEY": config.apiKey,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}), // Add any required payload here
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log("更新成功:", result);
      setSuccessMessage("控制指标更新成功！"); // Set success message
    } catch (error) {
      console.error("更新失败:", error);
      setError("更新失败，请重试"); // Set error message
    } finally {
      setLoading(false);
    }
  };

  // Function to render the data as key-value pairs
  const renderKeyValuePairs = () => {
    if (!data) return null;

    return (
      <div className="key-value-container">
        {Object.entries(data).map(([project, waterItems]) => (
          <div key={project} className="project-section">
            <h5 className="project-title">{project}</h5>
            {Object.entries(waterItems).map(([waterItem, parameters]) => (
              <div
                key={`${project}-${waterItem}`}
                className="water-item-section"
              >
                <h4 className="water-item-title">{waterItem}</h4>
                <div className="parameter-grid">
                  {Object.entries(parameters).map(([parameter, range]) => (
                    <div
                      key={`${project}-${waterItem}-${parameter}`}
                      className="parameter-item"
                    >
                      <span className="parameter-key">
                        {parameterTranslations[parameter] || parameter}:
                      </span>
                      <span className="parameter-value">{range}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="update-control-parameters">
      <button onClick={handleUpdate} disabled={loading}>
        {loading ? "更新中..." : "更新控制指标"}
      </button>
      {successMessage && <p className="success-message">{successMessage}</p>}
      {error && <p className="error-message">{error}</p>}

      {/* Display the key-value pairs */}
      <div className="data-container">{renderKeyValuePairs()}</div>
    </div>
  );
}

export default UpdateControlParameters;
